import { EventModel } from '@/models/Event.model'
import axios from 'axios'

class HttpException extends Error {
    public status: number
    public message: string
    constructor(status: number, message: string) {
        super(message)
        this.status = status
        this.message = message
    }
}

// have a look at this link for other GET request filters and parameters
// https://strapi.io/documentation/3.0.0-beta.x/content-api/parameters.html#filters
class EventWebservice {
    public async getEvents() {
        try {
            // get all venues
            const response = await axios.get<EventModel[]>('/events')
            return response.data
        } catch (error) {
            console.error(error)
            throw new HttpException(error.response.status, 'Could not fetch venues')
        }
    }
}

export const eventWebservice = new EventWebservice()
